<template>
  <CRow>
    <CCol col="12">
      <CRow>
        <CCol col="6">
          <AppForm 
            vo-name="MemberSearchTermVo"
            @changed="onSearchTermChange"
          />
        </CCol>
         <CCol col="3">
          <LoadingStateButton
            @click="onSearchMembers"
            :text="i18nMessage.Search"
            color="primary"
            :loading="searchMemberLoading"
          />
        </CCol>
      </CRow>
      <CCard>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="membersUiMeta"
            :items="members"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #cellphone="{item}">
              <td>
                {{item.cellphone ? item.cellphone : ''}}
              </td>
            </template>
            <template #home_phone="{item}">
              <td>
                {{item.home_phone ? item.home_phone : ''}}
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{members.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'Members',
  data () {
    return {
      activePage: 1,
      searchTerm: '',
      searchMemberLoading: false,
    }
  },
  components: {
    AppForm,
    LoadingStateButton,
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      members: state => state.member.members,
      membersUiMeta: state => state.member.membersUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      listMembers: 'member/listMembers',
    }),
    ...mapMutations({
      setMembers: 'member/setMembers',
    }),
    rowClicked (item) {
      this.$router.push({path: `member/${item.invisible_id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
    onSearchTermChange (data) {
      this.searchTerm = data.search_term
    },
    onSearchMembers() {
      this.searchMemberLoading = true
      this.setMembers([])
      this.listMembers({
        searchTerm: this.searchTerm,
      }).then(() => {
        this.searchMemberLoading = false
      })
    }
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
    this.setMembers([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>
